/*       */

import { gql } from '@apollo/client';

export default gql`
    query broadcastsQuery($startIndex: Int, $stopIndex: Int, $filterBy: [JSON], $orderBy: [JSON], $excludeBy: [JSON]) {
        count: count(dataType: "broadcast", filterBy: $filterBy, excludeBy: $excludeBy)
        records: broadcasts(startIndex: $startIndex, stopIndex: $stopIndex, filterBy: $filterBy, orderBy: $orderBy, excludeBy: $excludeBy) {
            id
            active
            message
            recipientTeams {
                id
                name
            }
            recipientUsers {
                id
                name
                image
            }
            startDate
            expireDate
            metadata
            parent
            createdBy {
                id
                name
                image
            }
            createdDate
            modifiedDate
            modifiedBy {
                id
                name
                image
            }
        }
    }
`;
